const status_dialog = {
	description: "Ändern Sie hier den Status Ihres Geräts.",
	status: {
		created_snapshot: "Snapshot wurde zu VPS <strong>{{name}}</strong> hinzugefügt.",
		deleted_snapshot: "Snapshot <strong>{{name}}</strong> wurde erfolgreich gelöscht.",
		forced_reset: "VPS <strong>{{name}}</strong> wird zurückgesetzt.",
		forced_shutdown:
			"VPS <strong>{{name}}</strong> wird heruntergefahren, dies kann einige Sekunden dauern.",
		reboot:
			"Wir haben das Betriebssystem von VPS <strong>{{name}}</strong> gebeten, neu zu starten.",
		rollback: "Ihr VPS wurde mithilfe des Snapshots <strong>{{name}}</strong> wiederhergestellt.",
		shutdown:
			"Wir haben das Betriebssystem von VPS <strong>{{name}}</strong> gebeten, herunterzufahren. Beachten Sie, dass dies einen Moment dauern kann.",
		start: "VPS <strong>{{name}}</strong> wird gestartet, dies kann einige Sekunden dauern.",
		updated_snapshot: "Snapshot <strong>{{name}}</strong> wurde erfolgreich geändert.",
	},
	title: "VPS-Status ändern",
};

export default status_dialog;
